import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.cookieService.get('auth');

    let modifiedRequest = request;

    // Agregar la cabecera Authorization si el token está presente
    if (token) {
      modifiedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}` // O cualquier cabecera que utilice tu API
        },
        withCredentials: true // Asegura que las solicitudes incluyan cookies o credenciales
      });
    } else {
      // Incluso si no hay token, asegurarse de que withCredentials esté presente en todas las solicitudes
      modifiedRequest = request.clone({
        withCredentials: true // Asegura que las solicitudes incluyan cookies o credenciales
      });
    }

    return next.handle(modifiedRequest);
  }
}
